import { Box } from "@mui/material";
import rthgMockup from "../../assets/mock-ups/rthg.png";

export function RthgJobContent() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      pt={{ xs: 4, md: 6 }}
      width="100%"
    >
      <Box
        component="img"
        src={rthgMockup}
        alt="RTHG app mockup"
        sx={{
          borderRadius: 0,
          height: { xs: "280px", sm: "350px", md: "450px" },
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </Box>
  );
}
